export const validations = {
  startDate: {
    required: true,
  },
  endDate: {
    required: true,
  },
};
